import React, { useContext, useEffect, useState } from "react";
import { message } from "antd";
import { AuthContext } from "../../context/auth-context/AuthContext";
import logoInmersial from "../../assets/logo-inmersial-horizontal.png";
import "./PantallaLogin.css";

const base_url = process.env.REACT_APP_BASE_URL;

//se elige un fondo por dia: todos los que entran ese dia ven la misma vista
const indiceDelDia = (cantidad) => {
  const hoy = new Date();
  const dias = Math.floor(
    Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()) / 86400000
  );
  return dias % cantidad;
};

const IconoUsuario = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
  </svg>
);

const IconoCandado = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

export const PantallaLogin = () => {
  const { login } = useContext(AuthContext);
  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [verClave, setVerClave] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [fondo, setFondo] = useState(null);
  const [mostrarAyudaClave, setMostrarAyudaClave] = useState(false);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/login-fondos/fondos.json`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((data) => {
        const lista = (data.fondos || []).filter((f) => f.imagen);
        if (!lista.length) return;
        const elegido = lista[indiceDelDia(lista.length)];
        //se muestra recien cuando la imagen termino de cargar, para que no aparezca a medias
        const img = new Image();
        img.onload = () => setFondo(elegido);
        img.src = elegido.imagen;
      })
      .catch(() => {
        //sin fondos queda el degradé de la marca
      });
  }, []);

  const ingresar = async (e) => {
    e.preventDefault();
    if (!usuario.trim() || !clave) {
      setError("Completá tu usuario y contraseña.");
      return;
    }
    setError(null);
    setCargando(true);
    try {
      const res = await fetch(`${base_url}/users/login`, {
        body: JSON.stringify({ username: usuario.trim(), password: clave }),
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });
      if (!res.ok) {
        setError(
          res.status >= 500
            ? "El servidor no responde. Intentá de nuevo en unos minutos."
            : "Usuario o contraseña incorrectos. Revisá los datos e intentá de nuevo."
        );
        return;
      }
      const data = await res.json();

      localStorage.setItem(
        "authState",
        JSON.stringify({
          griftin_token: data.auth.access,
          griftin_refresh_token: data.auth.refresh,
          griftin_userId: data.userProfile.id,
          griftin_username: data.userProfile.firstName,
          griftin_role: data.userProfile.role,
        })
      );
      login({
        isLogged: true,
        username: data.userProfile.firstName,
        token: data.auth.access,
        refreshToken: data.auth.refresh,
        userId: data.userProfile.id,
        role: data.userProfile.role,
      });
      message.success(`Bienvenido/a ${data.userProfile.firstName}`);
    } catch (err) {
      setError("No pudimos conectar con el servidor. Revisá tu conexión.");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="pl">
      <div
        className={`pl-fondo${fondo ? " pl-fondo--visible" : ""}`}
        style={fondo ? { backgroundImage: `url("${fondo.imagen}")` } : undefined}
      />
      <div className="pl-velo" />

      <header className="pl-top">
        <img src={logoInmersial} alt="Inmersial" className="pl-logo" />
        <a href="https://inmersial.com.ar" target="_blank" rel="noreferrer" className="pl-web">
          inmersial.com.ar ↗
        </a>
      </header>

      <main className="pl-centro">
        <form className="pl-card" onSubmit={ingresar} noValidate>
          <div className="pl-iso">
            <img src={logoInmersial} alt="" />
          </div>
          <h1 className="pl-titulo">
            Bienvenido a <span>Inmersial Designer</span>
          </h1>
          <p className="pl-sub">Entrá para seguir editando tus recorridos.</p>

          {error && (
            <div className="pl-error" role="alert">
              {error}
            </div>
          )}

          <label className="pl-oculto" htmlFor="pl-usuario">Usuario</label>
          <div className={`pl-campo${error ? " pl-campo--error" : ""}`}>
            <IconoUsuario />
            <input
              id="pl-usuario"
              name="username"
              autoComplete="username"
              placeholder="Usuario"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              autoFocus
            />
          </div>

          <label className="pl-oculto" htmlFor="pl-clave">Contraseña</label>
          <div className={`pl-campo${error ? " pl-campo--error" : ""}`}>
            <IconoCandado />
            <input
              id="pl-clave"
              name="password"
              type={verClave ? "text" : "password"}
              autoComplete="current-password"
              placeholder="Contraseña"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
            />
            <button type="button" className="pl-ver" onClick={() => setVerClave((v) => !v)}>
              {verClave ? "Ocultar" : "Mostrar"}
            </button>
          </div>

          <button type="submit" className="pl-boton" disabled={cargando}>
            {cargando ? (
              <>
                <span className="pl-spin" /> Ingresando…
              </>
            ) : (
              "Ingresar al editor"
            )}
          </button>

          <div className="pl-links">
            <button type="button" className="pl-link" onClick={() => setMostrarAyudaClave((v) => !v)}>
              ¿Olvidaste tu contraseña?
            </button>
            <a href="https://inmersial.com.ar" target="_blank" rel="noreferrer">
              Pedí una demo
            </a>
          </div>
          {mostrarAyudaClave && (
            <p className="pl-ayuda">
              Pedile a soporte de Inmersial que te la restablezca.
            </p>
          )}
        </form>
      </main>

      {fondo && (
        <div className="pl-credito">
          <i /> Estás viendo: {fondo.titulo}
        </div>
      )}
      <div className="pl-pie">© {new Date().getFullYear()} Inmersial</div>
    </div>
  );
};
